import React from 'react';
import MeAgendaContainer from '../../../Components/Dashboards/Me/MeAgendaContainer';

export default function MeFW() {
    return (
        <div className='page-body'>
            <MeAgendaContainer defaultTab="Doctor" />
        </div>
    );
}
